import { motion } from 'motion/react';
import styled from 'styled-components';

export const StyledMotionGalleryEditorMediaItem = styled(motion.div)`
    display: flex;
    width: 100%;
    height: 100%;
`;
